import { Box, Paper } from "@mui/material"
import Drawer from "@mui/material/Drawer"
import type { ReactElement, ReactNode } from "react"
import { useState } from "react"
import { z } from "zod"

import { FilterHeader } from "@/screens/Companies/components/filters/FilterHeader"

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SearchFilterDrawerPropsSchema = z.object({
  open: z.boolean(),
  toggleDrawer: z.function(),
  children: z.custom<ReactNode>(),
  clear: z.function(),
  isClearButtonEnabled: z.boolean().optional().default(true),
  width: z.number().optional(),
  testId: z.string().optional(),
})

type SearchFilterDrawerProps = z.input<typeof SearchFilterDrawerPropsSchema>

export const SearchFilterDrawer = ({
  open,
  toggleDrawer,
  children,
  clear,
  isClearButtonEnabled = true,
  width = 352,
  testId,
}: SearchFilterDrawerProps): ReactElement => {
  const [randFilterKey, setRandFilterKey] = useState(crypto.randomUUID())

  const handleClear = () => {
    setRandFilterKey(crypto.randomUUID())
    clear()
  }
  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={toggleDrawer}
      PaperProps={{
        className: "rounded-l-[1.25rem] h-full max-h-screen",
        sx: { width },
      }}
      slotProps={{
        backdrop: {
          classes: {
            root: "bg-transparent",
          },
        },
      }}
      elevation={4}
    >
      <Box
        className='flex h-full flex-col overflow-hidden'
        style={{ maxWidth: width }}
        role='presentation'
        component={Paper}
        elevation={0}
        {...(testId ? { "data-testid": testId } : {})}
      >
        <div className='shrink-0 p-4'>
          <FilterHeader onClear={handleClear} isClearButtonEnabled={isClearButtonEnabled} onClose={toggleDrawer} />
        </div>

        {/* Filter content: the section before the "Account Manager" filter */}
        <div className='flex grow flex-col overflow-hidden' key={randFilterKey}>
          {children} {/* All filters will go here */}
        </div>

        <div className='shrink-0 border-t border-gray-300 p-4'>{/* Footer, if needed */}</div>
      </Box>
    </Drawer>
  )
}
